import React, { Component } from "react";
import { Row, Col, Dropdown, Menu, Image, notification, Checkbox } from "antd";
import "./ListUser.css";
import Config from "../../config";
import { updateUserList } from "../../store/broadcaster/BroadcastRegister";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import axios from "axios";
import { MoreOutlined } from '@ant-design/icons';

export default class userTableData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      getValue: [],
    };
  }

  handleResendCreds = async () => {
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
    };
    let postData = {
      EMail: this.state.getValue.Email,
      TenantID: sessionStorage.getItem("Tanent"),
      URL: `https://${window.location.hostname}`,
    };

    axios
      .post(Config.api + "/forgotPassword", postData, axiosConfig)
      .then((res) => {
        this.openNotification(res.data.Message);
      })
      .catch((err) => {
        this.openNotification({ Message: "Something went wrong..." });
      });
  };

  onClickofmenu = () => {
    this.props.resetSelectedRows();
    this.props.getType("edit", this.state.getValue);
  };

  Getvalue = (data) => {
    this.setState({
      getValue: data,
    });
  };

  DeleteUser = async () => {
    let data = await fetch(Config.api + "/DeleteUser", {
      method: "POST",
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        UserName: this.state.getValue.Email,
        TenantID: sessionStorage.getItem("Tanent"),
        ID: this.state.getValue.ID,
      }),
    });
    data = await data.json();
    if (data.Message === "User Deleted Successfully") {
      updateUserList.next("deactivate");
      this.openNotification(data);
      this.props.DeleteUserCallBack(this.props.currentPage);
      this.props.handleSearchExternal(true);
    } else {
      this.openNotification(data);
    }
  };

  openNotification = (res) => {
    notification.open({
      description: res.Message,
    });
  };

  render() {
    //console.log("this props", this.props);
    let menu;
    if (this.props.activeTab === "ActiveUsers") {
      menu = (
        <Menu>
          <Menu.Item key="1" onClick={this.onClickofmenu}>
            <b>Edit Information</b>
          </Menu.Item>
          <Menu.Item key="2" style={{ color: "red" }} onClick={this.DeleteUser}>
            Deactivate User
          </Menu.Item>
          <Menu.Item key="3" onClick={this.handleResendCreds}>
            <b>Resend Credentials</b>
          </Menu.Item>
        </Menu>
      );
    }
    if (this.props.activeTab === "RegisteredUsers") {
      menu = (
        <Menu>
          <Menu.Item key="1" onClick={this.onClickofmenu}>
            <b>Activate User</b>
          </Menu.Item>
        </Menu>
      );
    }
    return (
      <tbody
        className="tdata"
        // id={this.props.id !== undefined ? this.props.id : ""}
      >
        {this.props.header[0] &&
          this.props.data[0] &&
          this.props.data.map((items, index) => {
            let keys = Object.keys(items);
            // console.log(this.props.header)
            // let Critical = {};
            return (
              <tr className="table-data-card" key={index}>
                {
                  this.props.header[0].title == "Select" &&
                  <td
                    style={
                      this.props.header[0].display
                        ? { maxWidth: 102 }
                        : { display: "none" }
                    }
                    className={"m-0 p-0 px-1"}
                  >
                    <Checkbox 
                      className="m-0 p-0"
                      checked={this.props.selectedRows.includes(items)}
                      onChange={() => this.props.onSelectRow(items)}/>
                  </td>
                }
                {keys.map((item, i) => {
                  let link = items[item];


                 // ✅ Format CreatedDate
                   if (item === "CreatedDate" && link) {
                  if (this.props.activeTab !== "RegisteredUsers") {
                    //  console.log("Inside user list");
                     const date = new Date(link);
                     const month = String(date.getMonth() + 1).padStart(2, "0");
                     const day = String(date.getDate()).padStart(2, "0");
                     const year = date.getFullYear();
                     link = `${month}/${day}/${year}`;
                  } else {
                    //  console.log("Inside register");
                      link = link.split(" ")[0];
                  }
              }


                  return (
                    <td
                      key={i}
                      style={
                        this.props.header[i].display
                          ? { maxWidth: 102 }
                          : { display: "none" }
                      }
                      className={
                        this.props.header[i].displayName === "Mob" ||
                        this.props.header[i].displayName === "D.O.B"
                          ? "contact-no"
                          : ""
                      }
                    >
                      {/* {link} */}
                      {this.props.header[i].displayName != "TaxNPIMappings" && (
                        <EllipsisWithTooltip>
                          {this.props.header[i].title == "SLNo"
                            ? index +
                              this.props.limit * (this.props.currentPage - 1) +
                              1
                            : link}
                        </EllipsisWithTooltip>
                      )}
                    </td>
                  );
                })}
                <Col style={{ width: "21px" }} className="menu3-dot-Image mt-2">
                  <Dropdown overlay={menu} trigger={["click"]}>
                    <span 
                      style={{ userSelect: "none" }}                      
                      onClick={() => this.Getvalue(items)}>
                      <MoreOutlined 
                        type="more"
                        className="ml-1"
                        style={{ marginTop: "8px" }}
                      />
                    </span>
                  </Dropdown>
                </Col>
              </tr>
            );
          })}
      </tbody>
    );
  }
}
